export default "__VITE_ASSET__VysXmPZ1__"